import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon, ArrowLeftIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/home" className="flex items-center space-x-2">
                <SparklesIcon className="w-8 h-8 text-blue-600" />
                <span className="text-2xl font-bold text-gray-900">Smartera</span>
              </Link>
            </div>
            
            <div className="flex items-center space-x-4">
              <Link to="/home" className="text-gray-700 hover:text-blue-600 transition-colors">Trang chủ</Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors">Liên hệ</Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-4"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            Quay lại đăng ký
          </Link>
          <div className="flex items-start space-x-4">
            <ShieldCheckIcon className="w-8 h-8 text-blue-600 mt-1" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Chính sách bảo mật</h1>
              <p className="text-gray-600">Cập nhật lần cuối: 05/07/2025</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-blue max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Cam kết bảo mật</h2>
            <p className="text-gray-700 mb-4">
              Tại Smartera, chúng tôi coi trọng quyền riêng tư và cam kết bảo vệ thông tin cá nhân 
              của khách hàng. Chính sách này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ 
              thông tin của bạn.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Thông tin chúng tôi thu thập</h2>
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Thông tin cá nhân:</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Họ tên, email, số điện thoại</li>
                <li>Thông tin công ty và vị trí công việc</li>
                <li>Địa chỉ thanh toán và giao hàng</li>
                <li>Thông tin đăng nhập tài khoản</li>
              </ul>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Thông tin kỹ thuật:</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Địa chỉ IP và thông tin thiết bị</li>
                <li>Cookies và dữ liệu phiên làm việc</li>
                <li>Lịch sử truy cập và tương tác với website</li>
                <li>Thông tin về trình duyệt và hệ điều hành</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Cách sử dụng thông tin</h2>
            <p className="text-gray-700 mb-4">Chúng tôi sử dụng thông tin của bạn để:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Cung cấp và cải thiện dịch vụ</li>
              <li>Xử lý đơn hàng và thanh toán</li>
              <li>Gửi thông báo về dịch vụ và cập nhật</li>
              <li>Hỗ trợ khách hàng và giải quyết vấn đề</li>
              <li>Phân tích và cải thiện trải nghiệm người dùng</li>
              <li>Tuân thủ các yêu cầu pháp lý</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Chia sẻ thông tin</h2>
            <p className="text-gray-700 mb-4">
              Chúng tôi không bán, thuê hoặc chia sẻ thông tin cá nhân của bạn với bên thứ ba, 
              trừ các trường hợp sau:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Có sự đồng ý rõ ràng của bạn</li>
              <li>Với các đối tác dịch vụ cần thiết (hosting, thanh toán)</li>
              <li>Khi được yêu cầu bởi pháp luật</li>
              <li>Để bảo vệ quyền lợi và an toàn của chúng tôi</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Bảo mật dữ liệu</h2>
            <div className="bg-blue-50 p-6 rounded-lg mb-4">
              <h3 className="text-lg font-medium text-blue-900 mb-3">Các biện pháp bảo mật:</h3>
              <ul className="list-disc list-inside text-blue-800 space-y-2">
                <li>Mã hóa SSL/TLS cho tất cả truyền dữ liệu</li>
                <li>Firewall và hệ thống giám sát 24/7</li>
                <li>Xác thực hai yếu tố (2FA)</li>
                <li>Sao lưu dữ liệu định kỳ</li>
                <li>Kiểm tra bảo mật thường xuyên</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookies và công nghệ theo dõi</h2>
            <p className="text-gray-700 mb-4">
              Chúng tôi sử dụng cookies để cải thiện trải nghiệm của bạn:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-900 mb-2">Cookies cần thiết</h4>
                <p className="text-sm text-gray-700">Để website hoạt động bình thường</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-900 mb-2">Cookies phân tích</h4>
                <p className="text-sm text-gray-700">Để hiểu cách bạn sử dụng website</p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Quyền của bạn</h2>
            <p className="text-gray-700 mb-4">Bạn có quyền:</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Truy cập thông tin cá nhân</li>
                <li>Chỉnh sửa thông tin không chính xác</li>
                <li>Xóa tài khoản và dữ liệu</li>
              </ul>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Hạn chế xử lý dữ liệu</li>
                <li>Chuyển dữ liệu sang nhà cung cấp khác</li>
                <li>Phản đối việc xử lý dữ liệu</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Lưu trữ dữ liệu</h2>
            <p className="text-gray-700 mb-4">
              Chúng tôi lưu trữ thông tin của bạn chỉ trong thời gian cần thiết để:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Cung cấp dịch vụ theo hợp đồng</li>
              <li>Tuân thủ nghĩa vụ pháp lý</li>
              <li>Giải quyết tranh chấp</li>
              <li>Thực thi thỏa thuận</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Liên hệ về bảo mật</h2>
            <p className="text-gray-700 mb-4">
              Nếu bạn có câu hỏi về chính sách bảo mật hoặc muốn thực hiện quyền của mình:
            </p>
            <div className="bg-green-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium text-green-900 mb-3">Thông tin liên hệ:</h3>
              <div className="space-y-2 text-green-800">
                <p><strong>Email:</strong> privacy@smartera.uk</p>
                <p><strong>Điện thoại:</strong> +44 7537 120666</p>
                <p><strong>Địa chỉ:</strong> London, United Kingdom</p>
                <p><strong>Thời gian phản hồi:</strong> Trong vòng 72 giờ</p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Cập nhật chính sách</h2>
            <p className="text-gray-700 mb-4">
              Chúng tôi có thể cập nhật chính sách này để phản ánh các thay đổi trong 
              thực tiễn hoặc yêu cầu pháp lý. Chúng tôi sẽ thông báo về các thay đổi 
              quan trọng qua email hoặc thông báo trên website.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 pt-8 mt-12">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-600 text-sm mb-4 sm:mb-0">
              © 2025 Smartera. All rights reserved.
            </p>
            <div className="flex space-x-4 text-sm">
              <Link to="/terms" className="text-blue-600 hover:text-blue-700">
                Điều khoản sử dụng
              </Link>
              <Link to="/contact" className="text-blue-600 hover:text-blue-700">
                Liên hệ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
